import { Link, Navigate, useNavigate } from "react-router-dom";
import { PerformanceEditor } from "@/components/admin/PerformancesPanel";
import { usePlaylistItem } from "@/hooks/usePlaylists";
import { usePlaylistIdParam } from "@/hooks/useUrlParams";
import { useAuth } from "@/lib/auth";
import { routineVideoEnabled } from "@/lib/routineFeature";

export default function FinalVideoEditorPage() {
  return routineVideoEnabled ? <RoutineEditorPage /> : <Navigate to="/app/dashboard/home" replace />;
}

function RoutineEditorPage() {
  const id = usePlaylistIdParam();
  const { user } = useAuth();
  const navigate = useNavigate();
  const { data: playlist, loading, error } = usePlaylistItem(id);
  const back = id ? `/app/dashboard/playlist?playlist_id=${encodeURIComponent(id)}` : "/app/dashboard/home";
  const allowed = playlist && (playlist.user_id === user?.id || user?.app_metadata?.role === "admin");
  return (
    <main className="min-h-screen bg-[#f7f5f3] px-4 py-6 sm:px-6">
      <div className="mx-auto max-w-7xl space-y-6">
        <h1 className="text-xl font-semibold text-[#321b29]">Final Video Editor</h1>
        {id && loading ? <p role="status">Loading performance…</p> : !id || error || !allowed ? (
          <div className="space-y-3">
            <p role="alert">This performance is unavailable or you don’t have access to it.</p>
            <Link to="/app/dashboard/home" className="text-[#762a5c] underline">Back to dashboard</Link>
          </div>
        ) : (
          <PerformanceEditor key={id} performance={{ id, name: playlist.name, organizer: "Your performance" }}
            onBack={() => navigate(back)} onGenerated={() => navigate(back)} backLabel="Back to performance" />
        )}
      </div>
    </main>
  );
}
